import moment from "moment";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Select from "react-select";

import Modal from "../Modal";

import actions from "@/actions";
import ConfirmDialog from "@/components/ConfirmDialog";
import { SubmitButton } from "@/components/common";
import styles from "@/constants/reactSelectStyle";
import { getConstructionId } from "@/lib/common";

type Props = {
  onClose: () => void;
  title?: string;
  processTitle?: string;
  taskId: number;
};

const ExtraRequestModal: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const today = moment();
  const dateOptions = useMemo(() => {
    // 当日から6日後までの計7日間
    return Array.from({ length: 7 }, (_, i) => moment(today.toDate()).add(i, "days").toDate()).map((date) => {
      const v = moment(date).format("YYYY/MM/DD");
      return { label: v, value: v };
    });
  }, [today]);

  const [scheduleDate, setScheduleDate] = useState<string>(today.format("YYYY/MM/DD"));
  const [confirm, setConfirm] = useState<boolean>(false);
  const [done, setDone] = useState<boolean>(false);

  const handleSubmitScheduleDate = () => {
    setConfirm(true);
  };
  const handleSubmit = () => {
    dispatch(
      actions.schedule_chiba.createExtraRequest(
        { task_id: props.taskId, schedule_date: moment(scheduleDate).format("YYYY-MM-DD") },
        () => setDone(true),
        () => props.onClose()
      )
    );
  };

  const handleOpenScheduleList = () => {
    const constructionId = getConstructionId();
    const date = moment(scheduleDate, "YYYY/MM/DD").format("YYYY-MM-DD");
    window.open(`/#/${constructionId}/schedule_chiba?schedule_date=${date}`, "_blank", "noreferrer");
    props.onClose();
  };

  return (
    <>
      {done ? (
        // 特別申請作成完了。予定表画面を別タブで開くか確認する
        <ConfirmDialog cancelClickHandler={props.onClose} okClickHandler={handleOpenScheduleList}>
          <div>
            <p>{t("extra_request_created")}</p>
            <p>{t("open_schedule_list_confirmation")}</p>
          </div>
        </ConfirmDialog>
      ) : confirm ? (
        // 特別申請作成確認
        <ConfirmDialog cancelClickHandler={props.onClose} okClickHandler={handleSubmit}>
          <div>
            <div className="grid grid-cols-[auto_auto_1fr] mx-auto w-fit text-start">
              <span>{t("scheduled_date")}</span>
              <span>：</span>
              <span>{scheduleDate}</span>
              <span>{t("title")}</span>
              <span>：</span>
              <span>{props.title ?? ""}</span>
              <span>{t("process_title")}</span>
              <span>：</span>
              <span>{props.processTitle ?? ""}</span>
            </div>
            <br />
            <p>{t("extra_request_confirmation")}</p>
          </div>
        </ConfirmDialog>
      ) : (
        // 予定日選択
        <Modal title={`${t("extra_request")}：${t("select_scheduled_date")}`} closeHandler={() => props.onClose()}>
          <div className="modal-body" style={{ padding: "30px 60px", position: "static" }}>
            <div className="flex items-center schedule-date">
              <span className="whitespace-nowrap w-[60px] min-w-[60px] text-end px-[8px]">{t("scheduled_date")}</span>
              <div className="flex-grow overflow-auto w-[200px]" data-test-id={props["data-test-id"]}>
                <Select
                  options={dateOptions}
                  value={dateOptions.find((o) => o.value === scheduleDate) ?? null}
                  onChange={(option) => option && setScheduleDate(option.value)}
                  styles={styles}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-gray" onClick={props.onClose}>
              {t("cancel")}
            </button>
            <SubmitButton onClick={handleSubmitScheduleDate}>{t("decision")}</SubmitButton>
          </div>
        </Modal>
      )}
    </>
  );
};

export default ExtraRequestModal;
